import { CoreExecutorResult, } from "../../core/index.js";
import { PimAttribute, PimClass } from "../model/index.js";
import { PimExecutorResultFactory } from "./pim-executor-utils.js";
export async function executePimSetRegex(reader, createNewIdentifier, operation) {
    const resource = await reader.readResource(operation.pimResource);
    if (!PimAttribute.is(resource) && !PimClass.is(resource)) {
        return PimExecutorResultFactory.invalidType(resource, "pim:attribute | pim:class");
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...resource,
            pimRegex: operation.pimRegex,
        },
    ]);
}
//# sourceMappingURL=pim-set-regex-executor.js.map